import { useTranslation } from "react-i18next";
import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { Slider } from "@/components/ui/slider";

export function PersonalityField({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number) => void;
}) {
  const { t } = useTranslation("smartCreation");
  return (
    <Field className="rounded-md border border-line bg-surface p-3.5">
      <div className="flex w-full items-center justify-between gap-3">
        <FieldLabel>{t("objectives.personality.label")}</FieldLabel>
        <span className="text-xs text-muted-foreground">
          {value} · {t(`objectives.personality.values.${value}`)}
        </span>
      </div>
      <Slider
        aria-label={t("objectives.personality.label")}
        min={1}
        max={5}
        step={1}
        value={[value]}
        onValueChange={(next) => onChange(Array.isArray(next) ? (next[0] ?? 3) : next)}
      />
      <div className="flex w-full justify-between text-[11px] text-muted-foreground">
        <span>{t("objectives.personality.conservative")}</span>
        <span>{t("objectives.personality.aggressive")}</span>
      </div>
      <FieldDescription>{t("objectives.personality.hint")}</FieldDescription>
    </Field>
  );
}
